import React, { useState } from 'react'
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap'
import FormConfirmEmail from './headerAuthButton/authForms/FormConfirmEmail'
import axios from 'axios'
import { useForm } from 'react-hook-form'
import fontColorContrast from 'font-color-contrast'

const ModalChangeEmail = ({ form, isShow, handleClose, handleUpdatePage }) => {

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onChange',
    })
    const [isAllowClose, setIsAllowClose] = useState(true)

    const setIsAllowClear = (val) => {
        setIsAllowClose(val)
    }


    const [isLoading, setIsLoading] = useState(false)
    const [isConfirmMode, setIsConfirmMode] = useState(false)
    const [confirmResendData, setConfirmResendData] = useState(null)


    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');

    const onSubmit = (submitData) => {

        // const info = await fetchClientInfo()
        // console.log(submitData)
        const sendData = {
            ...form,
            ...submitData,
            jwt: localStorage.getItem('galaxy-token')
        }
        setIsLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/profile/change-email`, sendData)
            .then((response) => {
                if (response.data.res === 'Success') {
                    setIsConfirmMode(true)
                    setConfirmResendData(sendData)
                    setIsAllowClear(false)
                    setIsAlertError(false)
                }
                if (response.data.res === 'Error') {
                    setIsAlertError(true)
                    const errText = 'Такой адрес уже существует'
                    setTextOnError(errText)
                }
            }).catch(err => {
                console.error(err.message)
                setIsAlertError(true)
                const errText = 'Что-то пошло не так, попробуйте позже'
                setTextOnError(errText)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <Modal
            show={isShow}
            onHide={() => {
                if (isAllowClose) handleClose()
            }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="modal-login"
        >
            <Modal.Header style={{ padding: '12px 30px 20px 30px', alignItems: 'center' }}>
                <Modal.Title>Изменение Email</Modal.Title>
                <button
                    className='btn p-2 ml-auto'
                    onClick={() => {
                        handleClose()
                    }}
                    style={{ position: 'relative', zIndex: 100, }}
                >
                    <span style={{ color: '#000' }}>&#x2715;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {
                    isConfirmMode ?
                        <FormConfirmEmail
                            routeToConfirm='cabinet/profile/change-email'
                            data={{
                                setting: {
                                    button_color: '#bf2362',
                                    text_6: 'Введите код подтверждения высланный на новую почту',
                                    text_7: 'Успешно! На новую почту выслали пароль',
                                    text_8: 'Прислать заново код',
                                    text_9: 'Отправить код',
                                }
                            }}
                            handleResend={() => {
                                onSubmit(confirmResendData)
                            }}
                            confirmResendData={confirmResendData}
                            onFinish={() => {
                                handleUpdatePage()
                            }}
                        />
                        :
                        <form onSubmit={handleSubmit(onSubmit)}>

                            {
                                isAlertError &&
                                <Alert variant={'danger'} onClose={() => {
                                    setIsAlertError(false)
                                    setTextOnError('')
                                }} dismissible>
                                    <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка при отправке</Alert.Heading>
                                    <p className='mb-0'>{textOnError}</p>
                                </Alert>
                            }
                            <Form.Control
                                className='mb-0'
                                placeholder={"Введите новый Email"}
                                type="email"
                                {...register('new_email', {
                                    required: true,
                                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                })}
                            />
                            {
                                <Form.Control.Feedback type="invalid" className='d-block m-0' style={{ minHeight: 20 }}>
                                    {
                                        errors?.new_email?.type === 'required' &&
                                        'Обязательно к заполнению'
                                    }
                                    {
                                        errors?.new_email?.type === 'pattern' &&
                                        'E-mail заполнен некорректно '
                                    }
                                </Form.Control.Feedback>
                            }

                            <button
                                disabled={!isValid}
                                className='btn btn-primary btn-submit'
                                type='submit'
                                style={{
                                    backgroundColor: '#bf2362',
                                    color: fontColorContrast('#bf2362')
                                }}
                            >
                                {
                                    isLoading ?
                                        <Spinner animation='border' />
                                        :
                                        <div dangerouslySetInnerHTML={{ __html: "Отправить код" }}></div>
                                }
                            </button>
                        </form>
                }
                {/* <FormRegister inputsData={inputsData} setIsAllowClear={setIsAllowClear} /> */}
            </Modal.Body>
        </Modal>
    )
}

export default ModalChangeEmail